import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Carousel, CarouselControl, CarouselItem } from 'reactstrap';
let FontAwesome = require('react-fontawesome');

const apiKey = 'AYwfqOxVzR-CzcTZ3yOGnc-s_n3GJYwDgrTSURXfsreWTkScYC9qieVHNvSv1su3_TrQJwFRAimT7aSN7vzIGkF9LBSwX0rQLS7RBDUAnAkyQUbNLyz-U07xN5PnW3Yx';

class Push extends Component {    
    constructor(props) {
        super(props);
    
        this.state = {
            modal: false,
            allRestaurants: [],
            city:'',
            state: '',
            value: 10,
            loading: false
        };

        this.toggle = this.toggle.bind(this);
    }

    update = evt => {
        this.setState({ 
            [evt.target.name]: evt.target.value,
        });
    }

    handleChange = event => {
        this.setState({value: event.target.value});
    }
    
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    fetchData = () => {
        this.setState({ loading: true });

        // convert miles to meters
        let radius = this.state.value * 1600;//document.getElementById('radius').value * 1600;
        let city = this.state.city;//document.getElementById('city').value;
        let state = this.state.state;//document.getElementById('state').value;

        let yelpURL = new URL("https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?categories=restaurants&limit=50&location=" + city + ',+' + state + "&radius=" + radius);

        fetch(yelpURL, { headers: new Headers({ 'Authorization': 'Bearer ' + apiKey }) })
            .then((result) => {
                return result.json();
            }).then((json) => {
                this.setState({
                    loading: false,
                    modal: true,
                    allRestaurants: json.businesses
                });
            }).catch((err) => console.log(err));

        let geoSuccess = (position) => {
            let startPos = position.coords;
            document.getElementById('startLat').innerHTML = startPos.latitude;
            document.getElementById('startLon').innerHTML = startPos.longitude;
        };

        let geoError = (error) => {
            console.warn(`ERROR(${error.code}): ${error.message}`);
        }

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
    }

    render() {
        const { value } = this.state
        return (
            <section id="picker">
                <div className="container h-100">
                    <div className="row align-items-center h-100">
                        <div id="modal-container" className="col-xs-12 col-lg-6 mx-auto text-center tart">
                            <div className="section-title text-center" style={{background: 'white'}}>
                                <h2 id="grub" className="not-border section-heading"><span style={{background: '#fff'}}>Where Should I Go Eat?</span></h2>
                            </div>
                            <form>
                                <div className="form-row justify-content-center">
                                <div className="col-sm-5 text-left">
                                    <label htmlFor="city">City</label>
                                    <input type="text" name="city" id="city" className="form-control" value={this.state.city} onChange={this.update} placeholder="City" required="required"/>
                                </div>
                                <div className="col-sm-2 text-left">
                                    <label className="space text-left" htmlFor="state">State</label>
                                    <input type="text" name="state" id="state" value={this.state.state} onChange={this.update} className="form-control" placeholder="State" required="required"/>
                                </div>
                                </div>
                                <label htmlFor="radius">Distance</label>
                                <div className="form-row justify-content-center">
                                <p style={{color:'#fff', 'marginTop': '0px'}} className="col-sm-5 justify-content-center">
                                    <input type="range" className="custom-range slider" min="1" max="25" step="1" id="radius" value={this.state.value} onChange={this.handleChange}/>
                                    <br />
                                    <output id="rangevalue">{value}</output> miles
                                </p>
                                </div>
                            </form>
                            <div id="startLat" className="d-none"></div>
                            <div id="startLon" className="d-none"></div>
                            <div id="business-details">
                                {/* <!-- React App --> */}
                                <div>
                                <button id="submit" aria-live="polite" className="downloadbutton" onClick={this.fetchData} disabled={!this.state.city && !this.state.state}>Tell me!</button>
                                <p>{ this.state.loading && <i id="loading-icon" class="fas fa-spinner fa-spin"></i> }</p>
                                { this.state.modal && <RestaurantModal addRestaurant={restaurant => this.props.addRestaurant(restaurant)} toggle={this.toggle} isOpen={this.state.modal} restaurants={this.state.allRestaurants} /> }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

class RestaurantModal extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            generate: true,
            value: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.generateModal = this.generateModal.bind(this)
    }

    generateModal = () => {
        this.setState({ 
            generate: true
        });
    }

    handleChange = (event) => {
        this.setState({ value: event.target.value });
    }

    render() {
        let restaurants = this.props.restaurants.map(item => {
            let restaurantObj = {};
            restaurantObj.id = item.id;
            restaurantObj.alias = item.alias;
            restaurantObj.phone = item.display_phone;
            restaurantObj.image = item.image_url;
            restaurantObj.name = item.name;
            restaurantObj.rating = item.rating;
            restaurantObj.review_count = item.review_count;
            restaurantObj.address = item.location.address1;
            restaurantObj.city = item.location.city;
            restaurantObj.state = item.location.state;
            restaurantObj.zipcode = item.location.zip_code;
            restaurantObj.is_closed = item.is_closed;
            restaurantObj.coordinates = item.coordinates;
            restaurantObj.url = item.url;
            return restaurantObj;
        });

        // Filters out restaurants that are closed
        let openRestaurants = restaurants.filter(restaurant => (restaurant.is_closed === false));

        if (openRestaurants.length > 0) {
            return (
                <div>
                    <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                        <ModalBody>
                            <div className="pb-4 d-block">
                                <select id="select" className="d-block" onChange={this.handleChange}>
                                    <option value="random">Randomize</option>
                                    <option value="rating">Best Rating</option>
                                    <option value="dist">Closest Distance</option>
                                </select>
                            </div>
                            {this.state.generate && <RestaurantsCarousel addRestaurant={restaurant => this.props.addRestaurant(restaurant)} restaurants={openRestaurants} value={this.state.value}/>}
                        </ModalBody>
                        <ModalFooter>
                            {(this.state.value === "random" || this.state.value === "") && <Button color="primary" onClick={this.generateModal}>Next Restaurant</Button>}
                            {' '}
                            <Button color="secondary" onClick={this.props.toggle}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            );
        } else {
            return (
                <div>
                    <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                        <ModalHeader toggle={this.props.toggle} id="businessTitle">Try Again</ModalHeader>
                        <ModalBody>
                            <h4>We discovered no results!</h4>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
    }
}

class RestaurantsCarousel extends Component {
    constructor(props, context) {
        super(props);

        this.state = { activeIndex: 0 };

        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }

    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }

    next() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === this.props.restaurants.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? this.props.restaurants.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }
    
    // Calculates the distance between two coodinates                                               
    calculateDistance(lat1, lon1, lat2, lon2) {
        let radlat1 = Math.PI * lat1 / 180;
        let radlat2 = Math.PI * lat2 / 180;
        let theta = lon1 - lon2;
        let radtheta = Math.PI * theta / 180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 0.8684;
        return dist;
    }

    render() {
        const { activeIndex } = this.state;

        let filteredRestaurants = this.props.restaurants;
        let value = this.props.value;

        function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        }

        let keyIndex;

        if (value === 'dist') {
            // Adds the distance property to each restaurant
            filteredRestaurants.forEach(restaurant => (restaurant.distance = this.calculateDistance(restaurant.coordinates.latitude, restaurant.coordinates.longitude,
                document.getElementById('startLat').innerHTML, document.getElementById('startLon').innerHTML, { timeout: 10000 })));

            // Sorts restaurants by distance
            filteredRestaurants.sort(function (a, b) {
                return a.distance - b.distance;
            });

            keyIndex = 1;
        } else if (value === 'rating') {
            // Sorts restaurants by rating
            filteredRestaurants.sort(function (a, b) {
                return a.rating - b.rating;
            });
            filteredRestaurants.reverse();

            keyIndex = 2;
        } else {
            let localRandom = getRandomInt(0, 50);
            let restaurant = filteredRestaurants[localRandom];
            return <Restaurant addRestaurant={check => this.props.addRestaurant(check)} restaurant={restaurant} />;
        }

        let restaurantsRow = filteredRestaurants.map((restaurant) => {
            let mapUrl = `https://www.google.com/maps/search/?api=1&query=${restaurant.coordinates.latitude},${restaurant.coordinates.longitude}`
            let keyName = restaurant.id + keyIndex;
            return (
                <CarouselItem key={keyName} onExiting={this.props.onExiting} onExited={this.props.onExited}>
                    <h2 className='section-heading'>{restaurant.name}</h2>
                    <img src={restaurant.image} className="modal-img" alt="" />
                    <br></br>
                    <p>
                        <strong>{restaurant.rating}</strong> of 5 rating with <strong>{restaurant.review_count}</strong> reviews!
                    </p>
                    <br></br>
                    <p>
                        <strong>Located:</strong> {restaurant.address} {restaurant.city}, {restaurant.state} {restaurant.zipcode}
                    </p>
                    <p>
                        <strong>Phone Number:</strong> {restaurant.phone}
                    </p>
                    <p><a id="mapUrl" href={mapUrl}><FontAwesome name='map-pin'/>&nbsp;&nbsp;&nbsp;<strong>Get directions</strong></a></p>
                    { document.getElementById('login').innerHTML === 'Sign Out' && 
                        <a href id="favBlock" onClick={() => this.props.addRestaurant(restaurant)}><FontAwesome name='plus-circle'/>&nbsp;&nbsp;&nbsp;<strong></strong>Add to favorites</a>
                    }
                    <div className='text-center'>
                        <a href={restaurant.url} className="downloadbutton mx-auto" target="_blank">See Reviews</a>
                    </div>
                </CarouselItem>
            );
        });

        return (
            <Carousel activeIndex={activeIndex} next={this.next} previous={this.previous} interval={null}>
                {restaurantsRow}
                <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} className="d-none" />
                <a href className="carousel-control-next" role="button" tabIndex="0" onClick={this.next}>
                    <Button color="primary">Next Restaurant</Button>
                    <span className="sr-only">Next</span>
                </a>
            </Carousel>
        );
    }
}

class Restaurant extends Component {

    render() {
        let restaurant = this.props.restaurant; 
        let mapUrl = `https://www.google.com/maps/search/?api=1&query=${restaurant.coordinates.latitude},${restaurant.coordinates.longitude}`
        return (
            <div id={restaurant.id}>
                <h2 id="restaurantName" className='section-heading'>{restaurant.name}</h2>
                <img src={restaurant.image} className="modal-img" alt=""/>
                <br></br>
                <div className="text-center">
                    <p> 
                        <strong>{restaurant.rating}</strong> of 5 rating with <strong>{restaurant.review_count}</strong> reviews!
                    </p>
                </div>
                <div className='text-center'> 
                    <a href={restaurant.url} className="downloadbutton mx-auto" target="_blank">See Reviews</a>
                </div>
                <p>
                    <strong>Phone Number:</strong> {restaurant.phone}
                </p>
                <p> 
                    <strong>Located:</strong> {restaurant.address} {restaurant.city}, {restaurant.state} {restaurant.zipcode}
                </p>
                <p><a id="mapUrl" href={mapUrl}><FontAwesome name='map-pin'/>&nbsp;&nbsp;&nbsp;<strong>Get directions</strong></a></p>
                { document.getElementById('login').innerHTML === 'Sign Out' && 
                    <a href id="favBlock" onClick={() => this.props.addRestaurant(restaurant)}><FontAwesome name='plus-circle'/>&nbsp;&nbsp;&nbsp;<strong></strong>Add to favorites</a>
                }
            </div>
        );
    }
}

export default Push;